import React from 'react';
import { Link } from 'react-router-dom';
import { PasskeyManager } from '../../components/PasskeyManager';
import { cn } from '../../utils/cn';
import { Banner, Button, Field, Input, Section, buttonClasses } from '../../components/ui';

export interface SecuritySectionProps {
  hasEmail: boolean;
  hasTelegram: boolean;
  isLoading: boolean;
  currentPassword: string;
  onCurrentPasswordChange: (value: string) => void;
  newPassword: string;
  onNewPasswordChange: (value: string) => void;
  confirmPassword: string;
  onConfirmPasswordChange: (value: string) => void;
  onChangePassword: (e: React.FormEvent) => void;
  onDeleteAccount: () => void;
}

export const SecuritySection: React.FC<SecuritySectionProps> = ({
  hasEmail,
  hasTelegram,
  isLoading,
  currentPassword,
  onCurrentPasswordChange,
  newPassword,
  onNewPasswordChange,
  confirmPassword,
  onConfirmPasswordChange,
  onChangePassword,
  onDeleteAccount,
}) => (
  <div className="flex flex-col">
    <PasskeyManager />

    {hasEmail ? (
      <Section title="Passwort ändern">
        <form onSubmit={onChangePassword} className="flex flex-col gap-3">
          <Field label="Aktuelles Passwort" htmlFor="currentPassword">
            <Input
              type="password"
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => onCurrentPasswordChange(e.target.value)}
              required
              disabled={isLoading}
            />
          </Field>
          <Field label="Neues Passwort" htmlFor="newPassword" hint="Mindestens 8 Zeichen.">
            <Input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => onNewPasswordChange(e.target.value)}
              required
              minLength={8}
              disabled={isLoading}
              aria-describedby="newPassword-hint"
            />
          </Field>
          <Field label="Neues Passwort bestätigen" htmlFor="confirmPassword">
            <Input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => onConfirmPasswordChange(e.target.value)}
              required
              minLength={8}
              disabled={isLoading}
            />
          </Field>
          <Button type="submit" disabled={isLoading} loading={isLoading} className="self-start">
            Passwort ändern
          </Button>
        </form>

        <p className="mt-4 text-sm text-muted">
          Kennst du dein aktuelles Passwort nicht? Lass dir einen Reset-Link per E-Mail schicken.
        </p>
        <Link to="/forgot-password" className={cn(buttonClasses('secondary', 'sm'), 'mt-2 self-start')}>
          Passwort zurücksetzen
        </Link>
      </Section>
    ) : hasTelegram ? (
      <Section title="Passwort">
        <Banner tone="info">
          Als Telegram-Nutzer meldest du dich über das Telegram-Widget an. Ein Passwort brauchst du dafür nicht.
        </Banner>
      </Section>
    ) : null}

    <Section title="Gefahrenbereich">
      <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="font-medium text-danger-text">Konto löschen</p>
          <p className="text-sm text-muted">Alle deine Daten werden unwiderruflich gelöscht. Das kann nicht rückgängig gemacht werden.</p>
        </div>
        <Button type="button" variant="danger" onClick={onDeleteAccount} disabled={isLoading}>
          Konto löschen
        </Button>
      </div>
    </Section>
  </div>
);
